import {MenuStrategy} from "../MenuStrategy";

export class UtenteMenuStrategy extends MenuStrategy {
   constructor() {
    super('Utente', '', '');
  }
}
